import { DEVICE_TYPE } from '@hotjar/global-filters';
import { undelimit } from '../queryUtils';

function isDeviceType(value: string): value is DEVICE_TYPE {
  switch (value) {
    case DEVICE_TYPE.DESKTOP:
      return true;
    case DEVICE_TYPE.PHONE:
      return true;
    case DEVICE_TYPE.TABLET:
      return true;
  }
  return false;
}

export function parseDeviceList(value: string): DEVICE_TYPE[] {
  const values = undelimit(value);
  const devices = new Set<DEVICE_TYPE>(values.filter(isDeviceType));
  return [...devices].sort();
}
